import React, {FC} from 'react';
import {Breadcrumbs, Typography} from "@mui/material";
import {Link} from "react-router-dom";

import {SxType} from "@baseTypes/sx/sxTypes";
import SpinnerCustom from '../spinner/SpinnerCustom';
import {useTranslation} from "react-i18next";
import {IBreadcrumbItem} from "@ui/breadcrumbCustom/types";
import {sx} from './sx'
import HomeLinkBreadcrumb from "@ui/breadcrumbCustom/HomeLinkBreadcrumb";

interface IProps {
    breadcrumbs: IBreadcrumbItem[],
    isLoading?: boolean,
    sx?: SxType
}

const BreadcrumbCustom: FC<IProps> = ({
                                          breadcrumbs,
                                          isLoading,
                                          sx: sxProps
                                      }) => {

    const {t} = useTranslation()

    const list = breadcrumbs?.length >= 1 && breadcrumbs.map((item, index, array) => {
        const {path, label, onClick} = item;

        if (index === array.length - 1) {
            return (
                <Typography
                    onClick={onClick}
                    key={index}
                    variant={'body2'}
                    color="text.primary"
                >
                    {t(label)}
                </Typography>
            )
        }

        return (
            <Link
                onClick={onClick}
                key={index}
                to={path}
            >
                <Typography
                    variant={'body2'}
                    color="text.primary">
                    {t(label)}
                </Typography>
            </Link>
        )
    });


    if (isLoading) {
        return <SpinnerCustom/>
    }

    if (!breadcrumbs?.length) {
        return <></>
    }

    return (
        <Breadcrumbs
            sx={{
                ...sx.root,
                ...sxProps,
            }}
        >
            <HomeLinkBreadcrumb/>

            {list}
        </Breadcrumbs>


    );
};

export default BreadcrumbCustom;